<template>
  <container
    subHeaderTitle="PASS프라임<br /><b>고객센터</b>"
    :subHeaderText="title"
    subHeaderAlign="center"
  >
    <section class="form-area mb-180">
      <v-container class="py-0">
        <v-row justify="center">
          <v-col cols="12" md="6" sm="8">
            <v-divider class="mb-8" />
            <h3 class="help-info" v-html="content"></h3>
            <v-divider class="my-8" />
            <p>[고객센터]</p>
            <div class="pl-5 mt-2">
              <ul>
                <li>연락처 : 1688-4142</li>
                <li>업무시간 : 09:00 ~ 18:00 (주말, 공휴일 휴무)</li>
                <li>점심시간 : 12:00 ~ 13:00</li>
              </ul>
            </div>
            <div class="mt-12 mb-16 text-center">
              <v-btn class="result" rounded large depressed color="primary" v-if="result === 'SUCCESS'" @click.stop="$router.push({ name: 'Support' })">완료</v-btn>
              <v-btn class="result" rounded large depressed color="primary" v-else @click.stop="failCall()">확인</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- router Param 없을때 -->
    <v-dialog v-model="returnDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>정상적인 접근이 아닙니다.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="goReturn()">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </container>
</template>

<script>
import Container from "@/pages/container/index.vue";

export default {
  name: "PassPrimeResult",
  data: () => ({
    type:'', // contract / termination / compensation
    result:'', // SUCCESS / FAIL
    title:'',
    content:'',
    returnDialog : false,
  }),
  components: {
    Container
  },
  methods: {
    failCall() {
      const type = this.type; // contract / termination / compensation

      if (type === "contract") {
        this.$router.push({ name: "PassPrimeContract" });
      } else if (type === "termination") {
        this.$router.push({ name: "PassPrimeTermination" });
      }
    },
    goReturn() {
      this.$router.push({ name: "Support" });
    },
    msgChange(){
      const type = this.type        // contract / termination / compensation
      const result = this.result    // SUCCESS / FAIL
      if(type === 'contract') {
        if(result === 'SUCCESS'){
          this.title = '가입이 완료되었습니다.'
          this.content = '기타 문의사항은 고객센터 또는 help@finbridge.co.kr 로 문의 부탁드립니다.'
        } else {
          this.title = '가입이 정상적으로 처리되지 않았습니다!'
          this.content = '선불폰, 알뜰폰(MVNO), 법인명의로 이용중이시거나, 미성년자, 외국인, 국내거소신청자일 경우 가입할 수 없습니다. 또한, 일시정지, 미납고객의 경우 가입이 제한됩니다.<br/><br/> 기타 문의사항은 고객센터 또는 help@finbridge.co.kr로 문의 부탁드립니다.'
        }
      } else if(type === 'termination') {
        if(result === 'SUCCESS'){
          this.title = '해지처리가 완료되었습니다.'
          this.content = '기타 문의사항은 고객센터 또는 help@finbridge.co.kr 로 문의 부탁드립니다.'
        } else {
          this.title = '해지처리가 정상적으로 처리되지 않았습니다!'
          this.content = '선택하신 서비스에 현재 정상적으로 가입되어 있지 않습니다. 가입하신 서비스를 재확인하시고, 서비스 해지를 진행 부탁드립니다.<br><br>기타 문의사항은 고객센터 또는 help@finbridge.co.kr로 문의 부탁드립니다.'
        }
      } else if(type === 'compensation') {
        if(result === 'SUCCESS'){
          this.title = '보상신청이 완료되었습니다.'
          this.content = '접수일 기준으로 익일(영업일 기준) 전담 담당자가 고객님께 유선으로 연락드려서 신청서류 등을 상세히 안내 드릴 수 있도록 하겠습니다.<br /><br/>기타 문의사항은 고객센터 또는 help@finbridge.co.kr로 문의 부탁드립니다.';
        } else {
          this.title = '보상신청이 정상적으로 처리되지 않았습니다!'
          this.content = '선택하신 서비스에 현재 정상적으로 가입되어 있지 않거나 이미 보상신청을 완료하셨습니다.<br />가입하신 서비스 또는 보상신청 내역을 재확인하시고 보상신청 진행을 부탁드립니다.<br><br>서비스 해지자에 해당하시거나 기타 문의사항이 있으신 경우 당사 이메일(help@finbridge.co.kr)로 연락 주시면 답변드리겠습니다.'
        }
      }
    },
  },
  created() {
    this.type = this.$route.params.type
    this.result = this.$route.params.result

    if(!this.type){
      this.returnDialog = true
    }
  },
  mounted() {
    this.msgChange()
  },
};
</script>
